<section *ngIf="(organization$ | async) as organization; else loading">
  <div class="container d-flex">
    <ng-template #leftColumn>
      <app-organization-profile
        [isMy]="isMyOrganization$ | async"
        [isAuthView]="isAuthorized$ | async"
        [organization]="organization"
        (subscribe)="onSubscribe($event)"
        (unsubscribe)="onUnsubscribe($event)"
        (message)="onOpenMessageDialog()"
        (openAbout)="openAboutTab()"
        (inviteEmail)="inviteEmail($event)"
      >
      </app-organization-profile>
      <ng-container *ngIf="reviews$ | async; let reviews">
        <app-organization-references
          *ngIf="reviews.length"
          [readonly]="isMyOrganization$ | async"
          [reviews]="reviews"
          (publish)="onPublishReview($event)"
        ></app-organization-references>
      </ng-container>
    </ng-template>
    <div class="left-column d-none d-md-block">
      <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
    </div>
    <div class="middle-column d-block">
      <mat-tab-group
        animationDuration="0ms"
        [selectedIndex]="mapSectionToIndex(section$ | async)"
        (selectedTabChange)="tabChanged($event)"
        #tabs
      >
        <mat-tab label="Updates">
          <ng-template matTabContent>
            <div class="d-md-none">
              <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
            </div>
            <app-organization-updates
              [isMyOrg]="isMyOrganization$ | async"
              [messageCtx]="messageCtx"
              [orgId]="id$ | async"
              [posts]="posts$ | async"
            >
            </app-organization-updates>
          </ng-template>
        </mat-tab>
        <mat-tab label="About" [disabled]="!organization.org?.about">
          <ng-template matTabContent>
            <app-organization-about [info]="organization.org?.about"></app-organization-about>
          </ng-template>
        </mat-tab>
        <mat-tab *ngIf="isAuthorized$ | async" [disabled]="!organization.org?.counts?.members">
          <ng-template mat-tab-label>
            <div class="custom-tab"
              >Members <div *ngIf="organization.org?.counts?.members"> ({{organization.org?.counts?.members}})</div>
            </div>
          </ng-template>
          <ng-template matTabContent>
            <app-organization-members
              [term]="search$ | async"
              [page]="page$ | async"
              [members]="members$ | async"
              (search)="onSearch($event)"
              (setPage)="onSetPage($event)"
              (connect)="onConnect($event)"
              (disconnect)="onDisconnect($event)"
            ></app-organization-members>
          </ng-template>
        </mat-tab>
        <mat-tab *ngIf="isAuthorized$ | async">
          <ng-template mat-tab-label>
            <div class="custom-tab">
              <span *ngIf="isOrgType$ | async">Clubs / Chapters</span>
              <span *ngIf="isSchool$ | async">Chapters</span>
              <div *ngIf="organization.org?.counts?.clubs"> ({{organization.org?.counts?.clubs}}) </div>
            </div>
          </ng-template>
          <ng-template matTabContent>
            <app-organization-groups
              [isMy]="isMyOrganization$ | async"
              [term]="search$ | async"
              [page]="page$ | async"
              [groups]="groups$ | async"
              [isOrgType]="isOrgType$ | async"
              [isSchool]="isSchool$ | async"
              [orgName]="organization.name"
              (search)="onSearch($event)"
              (setPage)="onSetPage($event)"
              (join)="onJoin($event)"
              (leave)="onLeave($event)"
              (create)="onCreateClub($event)"
            >
            </app-organization-groups>
          </ng-template>
        </mat-tab>
        <mat-tab
          *ngIf="isAuthorized$ | async"
          [disabled]="!(isMyOrganization$ | async) && !organization.org?.counts?.jobs"
        >
          <ng-template mat-tab-label>
            <div class="custom-tab"
              >Jobs / Opportunities
              <div *ngIf="organization.org?.counts?.jobs"> ({{organization.org?.counts?.jobs}})</div>
            </div>
          </ng-template>
          <ng-template matTabContent>
            <app-organization-new-job
              *ngIf="isShowNewJobForm$ | async as isShowNewJobForm; else jobs"
              [job]="jobToEdit$ | async"
              [isCreatingNewJob]="isCreatingNewJob$ | async"
              (submitJob)="onSubmitJob($event)"
              (deleteJob)="onDeleteJob($event)"
              (cancel)="onHideNewJobForm()"
            >
            </app-organization-new-job>

            <ng-template #jobs>
              <button class="job-add" *ngIf="isMyOrganization$ | async" (click)="onShowNewJobForm(); false">
                <div class="icon">
                  <svg viewBox="0 0 14 14">
                    <use href="#circle-plus" />
                  </svg>
                </div>
                Post opportunity
              </button>

              <app-organization-jobs [jobs]="jobs$ | async" (loadMore)="onLoadMoreJobs()" (edit)="onEditJob($event)">
              </app-organization-jobs>
            </ng-template>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</section>

<ng-template #loading>
  <app-loader-2></app-loader-2>
</ng-template>
